import { USER_ROLE } from '@/constant/user'
import { toNumber } from 'lodash'
import { DATE_FORMAT } from '@/constant/date'
import { PAGINATION } from '@/constant/common'
const { yyyyMMDD } = DATE_FORMAT

export const InspectionConstant = {
  QUERY_KEY: {
    INSPECTION_TYPE: 'INSPECTION_TYPE',
    INSPECTIONS: 'INSPECTIONS',
    INSPECTION: 'INSPECTION',
    INSPECTION_TEMPLATE_SECTION: 'INSPECTION_TEMPLATE_SECTION',
    INSPECTION_SECTION: 'INSPECTION_SECTION',
    SEARCH_INSPECTION: 'SEARCH_INSPECTION',
    GET_AQL: 'GET_AQL',
    INSPECTION_SUMMARY: 'INSPECTION_SUMMARY',
    INSPECTIONS_ADVANCE_SUMMARY: 'INSPECTIONS_ADVANCE_SUMMARY',
    GET_PROPERTIES_FIELDS: 'GET_PROPERTIES_FIELDS',
  },

  INSPECTION_STATUS_ARRAY: [
    {
      key: 1,
      name: 'IN_PROGRESS',
      label: 'IN PROGRESS',
      value: 'IN_PROGRESS',
    },
    {
      key: 2,
      name: 'COMPLETED',
      label: 'COMPLETED',
      value: 'COMPLETED',
    },
    { key: 3, name: 'HOLD', label: 'HOLD', value: 'HOLD' },
    {
      key: 4,
      name: 'RE_CHECK',
      label: 'RE CHECK',
      value: 'RE_CHECK',
    },
    {
      key: 5,
      name: 'APPROVED',
      label: 'APPROVED',
      value: 'APPROVED',
    },
  ],
}

export const INSPECTION_SECTION_STATUS = {
  COMPLETED: {
    key: 1,
    value: 'COMPLETED',
    label: 'COMPLETED',
    text: 'COMPLETED',
  },
  INCOMPLETE: {
    key: 1,
    value: 'INCOMPLETE',
    label: 'INCOMPLETE',
    text: 'INCOMPLETE',
  },
}

export const INSPECTION_PERMISSION = {
  CREATE_EDIT: [USER_ROLE.ADMIN, USER_ROLE.INSPECTOR, USER_ROLE.SUPPLIER],
}

export const INSPECTION_TEXT = {
  moiTooltip:
    'Inspect Multiple Orders with one or multiple Style(s) from one Supplier',
  dateFomat: yyyyMMDD,
  searchInspection: 'Inspection No., Order No., Style No., Supplier, Factory',
}

export function storeLocalInspectionPageSize(size: number) {
  localStorage.setItem('inspection_page_size', size.toString())
}

export function getLocalInpspectionPageSize(): number {
  const pageSize = localStorage.getItem('inspection_page_size')

  return toNumber(pageSize) ? toNumber(pageSize) : PAGINATION.page_size
}

// - - START REQUEST REVISION CONTROL TYPE
export const REQUEST_REVISION = 'needs_revisions' as const // => change REQUEST_REVISION => NEEDS_REVISIONS
export const INSPECTION_TYPE_SUBMIT_FOR_REVIEW = 'submit_for_review' as const
export const COMMENT_SECTION = 'section' as const
export const COMMENT_SUB_SECTION = 'sub_section' as const
export const COMMENT_TASK = 'task' as const
export const COMMENT_INSPECTION = 'inspection' as const
export const COMMENT_INSPECTION_SUMMARY = 'inspection_summary' as const

export type REQ_REVISION_CATEGORY_TYPE = typeof REQUEST_REVISION
export type REQ_REVISION_COMMENT_TYPE =
  | typeof COMMENT_SECTION
  | typeof COMMENT_SUB_SECTION
  | typeof COMMENT_TASK
  | typeof COMMENT_INSPECTION
  | typeof COMMENT_INSPECTION_SUMMARY

export type INSPECTION_COMMENT_PAYLOAD = {
  type: 'new'
  json_value: any
  comment_type: REQ_REVISION_COMMENT_TYPE
  category: REQ_REVISION_CATEGORY_TYPE
  section_id?: string
  task_id?: string
}

export const mockTitle = {
  [`${COMMENT_INSPECTION_SUMMARY}`]: 'Inspection Summary',
  [`${COMMENT_INSPECTION}`]: 'Overall Comments',
}

export type INSPECTION_COMMENT_PARAM_TYPE = {
  inspectionId: string
  payload: INSPECTION_COMMENT_PAYLOAD
}

// - - END REQUEST REVISION CONTROL TYPE
